import { ChangeEvent } from 'react';
import { Box, FormControlLabel } from '@material-ui/core';

import { WidgetItem } from '@vyce/core/src/types';
import { AppCheckbox } from '@vyce/core/src/components/inputs';

import { useStyles } from '../styles';
import { InputProps } from '../types';

export const WidgetCheckboxItem = ({
  name,
  is_active,
  system_name,
  onChange,
}: WidgetItem & { onChange: (event: ChangeEvent<HTMLInputElement>) => void }) => {
  const classes = useStyles();
  const inputProps: InputProps = { 'data-system-name': system_name };

  return (
    <Box key={system_name} marginTop="12px">
      <FormControlLabel
        classes={{ label: classes.label }}
        control={
          <AppCheckbox
            variant="rectangle"
            onChange={onChange}
            color="primary"
            checked={is_active}
            inputProps={inputProps}
          />
        }
        label={name}
      />
    </Box>
  );
};
